import classes from "./Header.module.css";
import { useHistory } from "react-router-dom";
import city from "./../../../assets/images/city.png";

const city_logo = city;
const sponsor_logo = "./preveza_espa.png";
const Header = () => {
  const history = useHistory();

  const redirectHandler = () => {
    if (history.location.pathname !== "/") history.push("/");
  };

  return (
    <div className={[classes.header, classes.flexContainer].join(" ")}>
      <div className={classes.app_logo}>
        <img
          src={city_logo}
          alt="smartiscity logo"
          width="100%"
          onClick={redirectHandler}
        />
      </div>
      <div className={classes.epsa_logo}>
        <a href="https://www.espa-epirus.gr/projects/view/5038178" target='_blank'>
        <img
          src={sponsor_logo}
          alt="interreg logo"
          className={classes.epsa_logo_normal}
        />
        </a>
      </div>
    </div>
  );
};

export default Header;
